import * as types from '../mutation-types';
import EventBus from '../../event-bus'
import { encode } from 'js-base64';

const state = () => ({
    authenticated: false,
    self: {
        user_name: null,
        is_admin: null
    },
});

const actions = {
    login({ commit }, { user_name, password }) {
        // let authHeader = `Basic ${window.btoa(`${username}:${password}`)}`
        // axios.defaults.headers.common['Authorization'] = authHeader
        return axios.post('/Users/Authenticate', { user_name, password  }).then(response => {
            const auth = {
                username: response.data.user_name, password: encode(password), authenticated: true, is_admin: response.data.is_admin,
                token: response.data.token
                
            };

            localStorage.setItem('auth', JSON.stringify(auth));
            // axios.defaults.headers.common['Authorization'] = authHeader;
            window.axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.token;
            commit(types.LOGIN, auth);
            return response.data
        })
    },

    logout({ commit }) {
        localStorage.removeItem('auth');
        localStorage.removeItem('localUser');
        window.localStorage.removeItem("localFinancialFileId");
        EventBus.$emit('financial-file-id-changed');  
        delete axios.defaults.headers.common['Authorization'];
        commit(types.LOGOUT);
    },
  
};

const mutations = {
    [types.LOGIN](state, payload) {
        state.authenticated = true;
        state.self.is_admin = payload.is_admin;
        state.self.user_name = payload.username;
    },

    [types.LOGOUT](state) {
        state.authenticated = false;
        state.self.username = null;
        state.self.is_admin = null;
    },
};

const getters = {
    isAuthenticated: state => state.authenticated,
    isAdmin: state => state.self.is_admin,
    username: state => state.self.user_name || "Main User",
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};